<canvas ref="barChart"></canvas>
<script>
import { plugins } from "chart.js";
import { Bar } from "vue-chartjs";
import { ColorUtil } from '@/utils/colorUtil';

export default {
  name: "BarChart",
  extends: Bar,
  props: {
    title: {
      type: String,
      required: true,
    },
    dataSetLabel: {
      type: String,
      default: () => "",
    },
    labels: {
      type: Array,
      required: true,
    },
    data: {
      type: Array,
      required: true,
    },
  },
  watch: {
    // Re-render chart when any prop changes
    labels: "renderBarChart",
    data: "renderBarChart",
    title: "renderBarChart",
    dataSetLabel: "renderBarChart",
  },
  mounted() {
    this.renderBarChart();
  },
  methods: {
    renderBarChart() {
      this.renderChart(
        {
          labels: this.labels,
          datasets: [
            {
              backgroundColor: ColorUtil.generateColors(this.data.length),
              label: this.dataSetLabel,
              type: "bar",
              data: this.data,
            },
          ],
        },
        {
          responsive: true,
          maintainAspectRatio: false,
          title: {
            display: false,
            text: this.title,
            fontSize: 18,
            fontColor: "#000",
          },
          legend: {
            display: false,
          },
          scales: {
            yAxes: [
              {
                id: "y-axis-1",
                type: "linear",
                position: "left",
                ticks: {
                  beginAtZero: true,
                  suggestedMax: 50,
                },
                scaleLabel: {
                  display: this.dataSetLabel ? true : false,
                  labelString: this.dataSetLabel,
                },
              },
            ],
            xAxes: [
              {
                stacked: false,
                gridLines: {
                  display: false,
                },
              },
            ],
          },
        }
      );
    },
  },
};
</script>

<style scoped>
canvas {
  height: 250px !important;
}
</style>
